export const POPULAR_PLANS_SUCCESS = 'POPULAR_PLANS_SUCCESS';
export const POPULAR_PLANS_FAILURE = 'POPULAR_PLANS_FAILURE';
export const POPULAR_PLANS_API = 'POPULAR_PLANS_API';
export const POPULAR_PLANS_MOCK = 'POPULAR_PLANS_MOCK';
export const SELECTED_PLANS = 'SELECTED_PLANS';
export const DISPLAY_POPULAR_PERK_LIST = 'DISPLAY_POPULAR_PERK_LIST';
